import { track } from '@betterment/js-runtime';
import * as TestTrack from '@betterment-oss/test-track';
import $ from 'jquery';

initializeAnalytics();

function initializeAnalytics() {
  initializeTestTrack();
  initializeClickEventListener();
}

function initializeTestTrack() {
  void TestTrack.initialize({
    analytics: {
      trackAssignment(_visitorId, assignment, callback) {
        track(
          'SplitAssigned',
          {
            splitName: assignment.getSplitName(),
            splitVariant: assignment.getVariant() ?? '',
            splitContext: assignment.getContext(),
          },
          () => callback(true)
        );
      },
      alias: () => {},
      identify: () => {},
    },

    onVisitorLoaded(visitor) {
      window.analytics?.identify(visitor.getId());
    },
  });
}

function initializeClickEventListener() {
  $(document).on('click', '[data-track-event]', e => {
    var data = $(e.currentTarget).data();
    if (!data) {
      return;
    }

    handleSegmentEvent(data);
  });
}

function handleSegmentEvent(data: any) {
  var eventProps = getEventProperties(data);
  if (eventProps) {
    track(eventProps.eventName, eventProps.props);
  }
}

function getEventProperties(data: any) {
  const eventName = data.trackEvent;
  const props = {
    name: data.trackName,
    flow: data.trackFlow,
    module: data.trackModule,
    application: 'BettermentForBusiness',
    client: 'Web',
  };

  if (
    (eventName === 'ElementClicked' || eventName === 'ElementViewed') &&
    props.application &&
    props.name &&
    props.client
  ) {
    return {
      eventName,
      props,
    };
  }

  return undefined;
}
